import { getCountry } from '~~/common/js/universal/market-utils';

export const FAHRENHEIT = 'f';
export const CELSIUS = 'c';

const unitCodeMap = {
  [CELSIUS]: 'metric',
  [FAHRENHEIT]: 'imperial',
  default: 'metric',
};

export const getTemperatureUnit = (fromUser, market) => {
  const country = getCountry(market);
  const fromCountry = country === 'us' ? FAHRENHEIT : CELSIUS;
  const unitCode = fromUser === 'auto' ? fromCountry : fromUser;
  return unitCodeMap[unitCode] ?? unitCodeMap.default;
};
